import { LoginMethodType } from '@eika-infrastruktur/mobilbank-lib/src/nativeProps';

import type { BankIdSigningMethod } from '../../generated-types';

const getDefaultSigningMethod = (loginMethodType?: LoginMethodType, bankIdSigningMethod?: BankIdSigningMethod) => {
    if (loginMethodType === 'BIOMETRIC') return 'BIOMETRIC';
    return bankIdSigningMethod ? 'BANKID' : undefined;
};

export default getDefaultSigningMethod;
